<ng-container *sbPageAction>
  @if (isSplitButtonVisible()) {
    <sb-view-setting sbTooltip="{{'nav.viewMode' |translate}}" [itemName]="itemName()"
                     [currentViewSetting]="viewSettingObjectFromUserSetting()"></sb-view-setting>
  }
</ng-container>

<ng-template #filterPanelTemplate>
  <div>
    <ng-content select="[filter-panel]"></ng-content>
  </div>
</ng-template>


@let isCardDisplay = isCardDisplayed();
<div class="tw-flex tw-flex-col tw-border tw-rounded-xl tw-h-full fit-height-on-page"
>
  <div
    class="tableWrapperReference tw-flex tw-flex-row tw-relative tw-flex-1 tw-min-h-[500px] tw-border tw-border-solid tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-rounded-xl tw-bg-sbGray-50/30 dark:tw-bg-[#2e3648]">
    <div class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl tw-flex tw-h-full tw-overflow-visible"
         [ngClass]="{'tw-absolute tw-left-0 tw-inset-y-0 tw-min-w-auto tw-z-20' : isCardDisplay }"
    >
      <div class="tw-sticky tw-top-0 sm:tw-top-[80px] tw-h-fit">
        <ng-template [ngTemplateOutlet]="filterPanelTemplate"></ng-template>
      </div>
      @if (filterPanel) {
        <div
          class="tw-flex tw-border-0 tw-border-x tw-border-sbGray-500 tw-border-solid tw-w-2 tw-bg-white dark:tw-bg-sbGray-930 dark:tw-border-sbGray-50"
        >
        </div>
      }
    </div>
    <div
      class="tw-flex tw-flex-col tw-w-full tw-relative tw-rounded-r-xl tw-overflow-hidden"
      [ngClass]="{'!tw-ml-17' : isCardDisplay }"

    >
      <!--
      @if (loading) {
        <sb-loading-spinner class="tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-rounded-r-xl"
                            [loadingDelay]="1"></sb-loading-spinner>
      }
      -->

      @if (!loading()) {
        @if (isCardDisplay) {
          <div @fadeIn class="tw-overflow-hidden tw-pb-18 scrollbar-custom tw-min-w-70">
            <div
              class="tw-overflow-auto tw-bg-sbGray-50 dark:tw-bg-sbGray-950 scrollbar-custom tw-min-w-70 tw-pl-0 tw-transition-all tw-duration-500 tw-ease-in-out "
              [ngClass]="{'sm:tw-pl-67 tw-pl-65' : isFilterPanelOpen}"
            >
              <table class="table table-hover tableCardHeaderPadding">
                <thead>
                <ng-template [ngTemplateOutlet]="tCardHead ? tCardHead : thead"></ng-template>
                </thead>
                <tbody>
                </tbody>
              </table>
            </div>
            @if (additionalInputTop) {
              <ng-template [ngTemplateOutlet]="additionalInputTop"></ng-template>
            }
            <div
              class="tw-grid sm:tw-gap-5 sm:tw-p-5 tw-gap-3.5 tw-p-3.5 2xl:tw-grid-cols-3 lg:tw-grid-cols-2 tw-grid-cols-1 tw-overflow-auto tw-h-full scrollbar-custom"
              [ngClass]="{
    '6xl:tw-grid-cols-8 5xl:tw-grid-cols-7 4xl:tw-grid-cols-5 3xl:tw-grid-cols-4' : !isSplitscreen,
    '6xl:tw-grid-cols-6 5xl:tw-grid-cols-5 4xl:tw-grid-cols-4' : isSplitscreen
    }"
            >@if (card) {
              @for (item of itemsData; let i = $index; track i) {
                <ng-template [ngForOf]="[item]" [ngForTemplate]="card" let-item ngFor></ng-template>
              } @empty {
                <div>
                  <h3
                    class="tw-flex tw-text-xl tw-w-full 3xl:tw-col-span-4 xl:tw-col-span-3 md:tw-col-span-2">
                    <sb-icon icon="empty"></sb-icon>
                    {{ 'lang.globals.noDataFoundFilterMessage' | translate }}
                  </h3>
                </div>
              }
            } @else {
              <h3 class="red">No Card Template </h3>
            }
            </div>
          </div>
        } @else {
          @if (thead && tbody) {
            <!--
            <ng-scrollbar
              [track]="'horizontal'"
              [autoHeightDisabled]="false"
              [thumbClass]="'tw-h-10'"
            >
              <table class="table table-hover tw-mb-3">
                <thead>
                <ng-template [ngTemplateOutlet]="thead"></ng-template>
                </thead>
                <tbody>
                  @if (operatingMode() === 'selection' && tSelectionMode) {
                    <ng-template [ngTemplateOutlet]="tSelectionMode"></ng-template>
                  }
                  @if (iterateTableRows) {
                    @for (item of itemsData; track item.id; let i = $index) {
                      <ng-template [ngForOf]="[item]" [ngForTemplate]="tbody" let-item ngFor></ng-template>
                    } @empty {
                      <tr>
                        <td colspan="200">
                          <div class="tw-text-xl tw-font-bold">
                            {{ 'lang.globals.noData' |translate }}
                          </div>
                        </td>
                      </tr>
                    }
                  } @else {
                    <ng-template [ngTemplateOutlet]="tbody"></ng-template>
                  }
                </tbody>
              </table>
            </ng-scrollbar>
            -->
            <div class="tw-overflow-auto tw-h-full scrollbar-custom tw-min-w-82" @fadeIn [ngClass]="{'tw-rounded-xl': !filterPanel}">
              <table class="table table-hover">
                <thead #tableHead class="tw-sticky tw-z-40 tw-top-0">
                <ng-template [ngTemplateOutlet]="thead"></ng-template>
                </thead>
                <tbody>
                  @if (additionalInputTop) {
                    <tr>
                      <td colspan="100">
                        <ng-template [ngTemplateOutlet]="additionalInputTop"></ng-template>
                      </td>
                    </tr>
                  }
                  @if (iterateTableRows) {
                    @for (item of itemsData; track item.id; let i = $index) {
                      <ng-template [ngForOf]="[item]" [ngForTemplate]="tbody" let-item ngFor></ng-template>
                    } @empty {
                      <tr>
                        <td [colSpan]="999">
                          <h3 class="tw-text-xl tw-text-sbGray-900 dark:tw-text-sbGray-100 tw-p-5">
                            <sb-icon icon="empty"></sb-icon>
                            {{ 'lang.globals.noDataFoundFilterMessage' |translate }}
                          </h3>
                        </td>
                      </tr>

                    }
                  } @else {
                    <ng-template [ngTemplateOutlet]="tbody"></ng-template>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <h3 class="red">No List Template </h3>
          }
        }
      } @else {
        <div class="tw-overflow-auto tw-h-full scrollbar-custom">
          <sb-ghost-list [ghosts]="ghosts()" [isCardDisplay]="isCardDisplayed()"
                         [isSplitscreen]="isSplitscreen"
                         @fadeOut></sb-ghost-list>
        </div>
      }
      <div class="tw-relative tw-transition-all tw-duration-200 tw-ease-in-out tw-h-0 tw-shrink-0"
           [ngClass]="{'tw-h-16' : isMultiSelectEnabled() && tSelectionMode}">
        @if (isMultiSelectEnabled() && tSelectionMode) {
          <div @slideInOutBottom
               class="tw-relative tw-flex tw-items-center tw-border-0 tw-border-t tw-border-solid tw-border-sbGray-500 tw-z-10 tableBg tw-h-16 tw-py-2 tw-px-5"
          >
            <ng-template [ngTemplateOutlet]="tSelectionMode"></ng-template>
          </div>
        }
      </div>
      <div #tableBody class="tw-shrink-0">
        @if (!hidePagination || footerMore) {

          <div class="tw-border-0 tw-border-t tw-border-solid tw-border-sbGray-500 tw-z-20 tw-px-3">
            @if (paginationInitialized && !hidePagination) {
              <sb-comp-pagination
                [pagination]="pagination.value"
                (paginationChange)="changePagination($event)"
                [sizes]="sizes"
                [paginationString]="paginationString"
              ></sb-comp-pagination>
              <!--
                        <div (pageChange)="pageChange($event)" (pageSizeChange)="setMaxSize($event)"
                             *ngIf="paginationInitialized && !hidePagination"
                             [(page)]="page"
                             [boundaryLinks]="boundaryLinks" [showPageSize]="!isInModalContext"
                             [collectionSize]="options.pagination.value.resultcount" [maxSize]="maxSize" [sizes]="sizes" class="w-100"
                             sb-pagination>
                            <span class="d-none d-sm-inline-block" *ngIf="!isInIntegratedContext">
                            {{ paginationString }}
                            </span>
                        </div>
                        -->
            }
            @if (footerMore) {
              <div class="ml-3">
                <ng-content select="[footer-more]"></ng-content>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>

